module.exports = __webpack_public_path__ + "static/media/proposal_verification_audio.80fd3693.mp3";